
import React from 'react';
import { Fragment } from 'react';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { StatusBar } from '../StatusBar';

export class StatsPanel extends ArcaComponent {
    constructor(props) {
        super(props);
        this.state = {
            isError: false,
            statusText: '',
            statusItems: null
        };
    }

    resize() {
        this.setState({
            isSmartphone: ArcaHttpSystem.IsSmartphone
        });
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));

        ArcaHttpSystem.GetOnboardingInfoAsync(
            (statusItems => this.setState({ statusItems })),
            (msg => this.setState({ isError: true, statusText: msg }))
        )

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    render() {
        let { isError, statusText, statusItems } = this.state;
        return (
            <div className='article topAndBottomPanels rounded px-3 px-sm-4 py-3 py-sm-5' id='#enquire' >

                <StatusBar isError={isError} message={statusText} />

                {statusItems?.map((item, key) =>
                    <Fragment key={key}>
                        {item.FirstName} {item.LastName} - {item.State} - {item.Urgency}
                        <br/>
                    </Fragment>)

                }

            </div>
        )
    }
}